module.exports = "# 路由配置\n#### 准备工作\n```shell\n# 定位到你的项目目录\ncd path-to-your-object\n# 定位到项目src，以下所有的文件根目录都在此之下\ncd src\n```\n#### 新建一个文件\n```shell\n# 新建一个文件目录\nmkdir views/exercises\n# 新建一个文件\ntouch views/exercises/record.vue\n```\n#### 新增一个路由\n> routes中的key和value，分别代表url和页面的相对路径\n\n在根目录config中修改router.js如下\n```javascript\nexport default {\n  routes: {\n    'exercises/record': 'exercises/record',\n  }\n}\n```\n此时访问/exercises/record，即为record页内容，现在来写record页\n"


//////////////////
// WEBPACK FOOTER
// ./src/store/route.md
// module id = 155
// module chunks = 2